import { Component, Input } from '@angular/core';

import { CreditCardService } from '../../services/credit-card.service';

@Component({
  selector: 'payment-methods-form',
  templateUrl: './payment-methods-form.component.html',
  styleUrls: ['./payment-methods-form.component.scss'],
  standalone: false,
})
export class PaymentMethodsFormComponent {
  @Input() showInvoiceOption;
  @Input() contactEmail;
  @Input() set forceCreditCardPayment(value) {
    this._forceCreditCardPayment = !!value;
    this._selectCreditCardIfForced();
  }

  get forceCreditCardPayment() {
    return this._forceCreditCardPayment;
  }

  paymentMethods = this.creditCardService.paymentMethods;
  private _forceCreditCardPayment = false;

  constructor(private creditCardService: CreditCardService) {}

  private _selectCreditCardIfForced() {
    if (this._forceCreditCardPayment) {
      this.paymentMethods.paymentMethod = 'card';
    }
  }
}
